// extracted by mini-css-extract-plugin
export default {"header":"Performance_header__tA-N0"};